// material-ui
import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

export function theme() {
  let textPrimary;
  let textSecondary;
  let textDark;
  let textHint;
  let background;
  let paper;
  let menuCaption;
  let textInversePrimary;

  textPrimary = textInversePrimary = menuCaption = '#242c3a';
  textSecondary = '#1b212c';
  textDark = '#12171e';
  textHint = '#00000061';

  background = '#f0f2f8';
  paper = '#fafafb';

  return createTheme({
    palette: {
      mode: 'light',
      common: {
        black: '#232b38'
      },
      primary: {
        light: '#380f4',
        main: '#74737B',
        dark: '#3c3c3c',
        100: '#4c6fff'
      },
      secondary: {
        light: '#60696d',
        main: '#1C4E80',
        dark: '#25476A'
      },
      error: {
        light: '#ec4333',
        main: '#ff413a',
        dark: '#a20e00'
      },
      warning: {
        light: '#f6b333',
        main: '#f4a100',
        dark: '#aa7000'
      },
      info: {
        light: '#33d8dd',
        main: '#00cfd5',
        dark: '#009095'
      },
      success: {
        light: '#33bc87',
        main: '#00ac69',
        dark: '#007849'
      },
      grey: {
        300: '#425466',
        //400: value.grey400
      },
      bg: {
        100: '#f8f8f9'
      },
      textDark: {
        color: '#12171e'
      },
      text: {
        primary: textPrimary,
        secondary: textSecondary,
        dark: textDark,
        hint: textHint
      },
      background: {
        paper: paper,
        default: background
      }
    },
    typography: {
      fontFamily: `'Roboto', sans-serif`,
      h6: {
        fontWeight: 600,
        color: textSecondary,
        fontSize: '0.875rem'
      },
      h5: {
        fontSize: '1.125rem',
        color: textSecondary,
        fontWeight: 600
      },
      h4: {
        fontSize: '1.25rem',
        color: textSecondary,
        fontWeight: 500
      },
      h3: {
        fontSize: '1.5rem',
        color: textDark,
        fontWeight: 600
      },
      h2: {
        fontSize: '2rem',
        color: textDark,
        fontWeight: 600
      },
      h1: {
        fontSize: '2.2rem',
        color: textDark,
        fontWeight: 600
      },
      subtitle1: {
        fontSize: '0.875rem',
        fontWeight: 500,
        color: textSecondary,
        lineHeight: '1.643em'
      },
      subtitle2: {
        fontSize: '0.8125rem',
        fontWeight: 400
      },
      caption: {
        fontSize: '0.68rem',
        color: textHint,
        fontWeight: 500
      },
      body1: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.643em'
      },
      body2: {
        letterSpacing: '0em',
        fontWeight: 400,
        lineHeight: '1.643em'
      },
      menuCaption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        color: '#74737B',
        padding: '5px 15px 5px',
        textTransform: 'uppercase',
        marginTop: '10px'
      },
      subMenuCaption: {
        fontSize: '0.6875rem',
        fontWeight: 400,
        color: menuCaption,
        textTransform: 'capitalize'
      },
      subHeading: {
        color: 'red'
      },
      cardTitle: {
        color: '#74737B',
        fontSize: '1rem'
      },
      breadcrumbTitle: {
        fontWeight: 500,
        fontSize: '1.5rem',
        color: textDark
      }
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: '#fafafb',
            color:'#000000'
          },
        }
      },
      MuiList: {
        styleOverrides: {
          root: {
            overflow: 'hidden'
          }
        }
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: '1.3rem'
          },
          fontSizeInherit: {
            fontSize: 'inherit'
          },
          fontSizeLarge: {
            fontSize: '2.1875rem'
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            color: textInversePrimary,
            paddingTop: '12px',
            paddingBottom: '12px',
            '&.Mui-selected': {
              '& .MuiListItemIcon-root': {
                color: '#74737B'
              },
              color: '#74737B',
              backgroundColor: '#b4b4b4'
            },
            '&:hover': {
              backgroundColor: '#b4b4b4',
              color: '#74737B',
              '& .MuiListItemIcon-root': {
                color: '#74737B'
              }
            },
            button: {
              '&:hover': {
                backgroundColor: '#b4b4b4'
              }
            }
          }
        }
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            color: textInversePrimary,
            paddingTop: '12px',
            paddingBottom: '12px',
            '&.Mui-selected': {
              '& .MuiListItemIcon-root': {
                color: '#ffffff',
              },
              color: '#ffffff',
              backgroundColor: '#b4b4b4',
              borderRight: '3px solid #74737B',
              borderRadius: '0px'
            },
            '&:hover': {
              backgroundColor: '#b4b4b4',
              color: '#ffffff',
              borderRadius: '0px',
              '& .MuiListItemIcon-root': {
                color: '#ffffff',
              }
            },
            button: {
              '&:hover': {
                backgroundColor: '#b4b4b4',
              }
            }
          }
        }
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: '36px',
            color: textInversePrimary
          }
        }
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            boxShadow: 'none'
          }
        }
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            fontWeight: 600,
            fontSize: '0.875rem'
          },
          content: {
            color: textSecondary,
            fontWeight: 500
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          elevation1: {
            boxShadow: '0 4px 6px -2px rgb(0 0 0 / 12%), 0 2px 2px -1px rgb(0 0 0 / 5%)'
          },
          rounded: {
            borderRadius: '10px'
          }
        }
      },
      MuiCardHeader: {
        styleOverrides: {
          root: {
            color: textDark,
            padding: '24px'
          }
        }
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            padding: '24px'
          }
        }
      },
      MuiCardActions: {
        styleOverrides: {
          root: {
            padding: '24px'
          }
        }
      },
      // Table
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '16px 36px 16px 36px',
            whiteSpace: 'normal'
          },
          head: {
            padding: '16px 36px 16px 36px',
            color: textDark,
            fontWeight: 600
          },
          paddingCheckbox: {
            paddingLeft: '18px',
            position: 'relative'
          }
        }
      },
      MUIDataTableSelectCell: {
        styleOverrides: {
          fixedLeft: {
            position: 'unset'
          }
        }
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            background: background
          },
          MuiChip: {
            root: {
              backgroundColor: '#425466'
            }
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          colorDefault: {
            color: grey[100],
            backgroundColor: '#425466'
          },
          colorSecondary: {
            color: grey[100]
          },
          colorPrimary: {
            color: grey[100]
          },
          root: {
            color: grey[100]
          },
          outlined: {
            color: grey[500]
          },
          deleteIcon: {
            color: grey[500]
          }
        }
      },
      MuiTimelineDot: {
        styleOverrides: {
          filledGrey: {
            background: grey[300]
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: '#1b212c'
          },
          indeterminate: {
            color: '#242c3a'
          }
        }
      },
      MuiTimelineConnector: {
        styleOverrides: {
          root: {
            background: grey[300]
          }
        }
      },
      MuiTableContainer: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            maxWidth: '100%'
          }
        }
      },
      MuiAvatar: {
        styleOverrides: {
          colorDefault: {
            backgroundColor: '#00000061',
            color: grey[100]
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            color: textDark
          }
        }
      }
    }
  });
}

export default theme;
